var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9845 4.49251C14.7896 4.49832 14.6047 4.57975 14.4689 4.71956L6.74915 12.4393L4.27942 9.96956C4.21031 9.89758 4.12754 9.84012 4.03594 9.80053C3.94434 9.76094 3.84577 9.74003 3.74599 9.73901C3.64621 9.73799 3.54723 9.7569 3.45484 9.79462C3.36246 9.83233 3.27853 9.8881 3.20797 9.95866C3.13741 10.0292 3.08164 10.1132 3.04393 10.2055C3.00621 10.2979 2.9873 10.3969 2.98832 10.4967C2.98934 10.5965 3.01025 10.695 3.04984 10.7866C3.08943 10.8782 3.14689 10.961 3.21887 11.0301L6.21887 14.0301C6.35953 14.1707 6.55027 14.2497 6.74915 14.2497C6.94803 14.2497 7.13876 14.1707 7.27942 14.0301L15.5294 5.78011C15.6378 5.67476 15.7118 5.53913 15.7418 5.39099C15.7718 5.24285 15.7563 5.08912 15.6974 4.94993C15.6385 4.81074 15.5389 4.69259 15.4117 4.61097C15.2845 4.52935 15.1356 4.48806 14.9845 4.49251Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ec982013b61532d08ab7fe7d2c5f4098.svg";
export { ForwardRef as ReactComponent };